import React, { Component } from "react";
import AntdModal, { ModalProps } from "antd/lib/modal";
import PagePoint from "../page-point/pagePointEnhanced";
import { ConfigContext } from 'antd/lib/config-provider/context';
import { ConfigConsumer, ConfigConsumerEProps } from "../config-provider";
import "antd/lib/modal/style";

const { confirm, info, success, error, warning } = AntdModal;

interface IModalProps extends ModalProps{
  draggable?: boolean
}

const destroyAll = AntdModal.destroyAll

export default class Modal extends Component<IModalProps> {
  private simpleClass: string;
  private header: any;
  private contain: any;
  private modalContent: any;

  private mouseDownX: number = 0;
  private mouseDownY: number = 0;
  private deltaX: number = 0;
  private deltaY: number = 0;
  private sumX: number = 0;
  private sumY: number = 0;

  static destroyAll = destroyAll

  static contextType = ConfigContext as any;

  context: ConfigConsumerEProps;
  
  constructor(props) {
    super(props);
    this.simpleClass = Math.random().toString(36).substring(2);
  }

  static info = info;
  static confirm = confirm;
  static success = success;
  static error = error;
  static warning = warning;

  state = {
    visible: false,
  }

  handleMove = (event: any) => {
    const deltaX = event.pageX - this.mouseDownX;
    const deltaY = event.pageY - this.mouseDownY;

    this.deltaX = deltaX;
    this.deltaY = deltaY;

    this.modalContent.style.transform = `translate(${deltaX + this.sumX}px, ${deltaY + this.sumY}px)`;
  }

  show = () => {
    this.setState({ visible: true });
  }

  hide = () => {
    this.setState({ visible: false });
  }

  initialEvent = (visible: boolean) => {
    const { title } = this.props;
    const prefix = this.context ? this.context.getPrefixCls('modal') : 'ant-modal';
    if (title && visible) {
      setTimeout(() => {
        window.removeEventListener("mouseup", this.removeUp, false);
        this.contain = document.getElementsByClassName(this.simpleClass)[0];
        this.header = this.contain.getElementsByClassName(`${prefix}-header`)[0];
        this.modalContent = this.contain.getElementsByClassName(`${prefix}-content`)[0];
        if (this.header) {
          this.header.style.cursor = "all-scroll";
          this.header.onmousedown = (e) => {
            this.mouseDownX = e.pageX;
            this.mouseDownY = e.pageY;
            document.body.onselectstart = () => false;
            window.addEventListener("mousemove", this.handleMove, false);
          }
        }
        window.addEventListener("mouseup", this.removeUp, false);
      }, 0);
    }
    if(!visible) {
      this.mouseDownX = 0;
      this.mouseDownY = 0;
      this.deltaX = 0;
      this.deltaY = 0;
      this.sumX = 0;
      this.sumY = 0;
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { visible } = nextProps;
    if(typeof visible === 'boolean' && visible !== prevState.visible) {
      return {
        visible,
      }
    }

    return null;
  }

  removeMove = () => {
    window.removeEventListener("mousemove", this.handleMove, false);
  }

  removeUp = () => {
    document.body.onselectstart = () => true;
    this.sumX = this.sumX + this.deltaX;
    this.sumY = this.sumY + this.deltaY;
    this.removeMove();
  }

  componentDidMount() {
    const { draggable = true } = this.props;
    if(draggable) {
      this.initialEvent(this.props.visible);
    }
  }

  componentWillUnmount() {
    const { draggable = true } = this.props;
    if(draggable) {
      this.removeMove();
      window.removeEventListener("mouseup", this.removeUp, false);
    }
  }

  componentDidUpdate() {
    const { draggable = true } = this.props;
    if(draggable) {
      this.initialEvent(this.props.visible);
    }
  }

  render() {
    const { children, wrapClassName, ...other } = this.props;
    const defaultOpts = {
      destroyOnClose: true
    };
    const opts = {
      ...defaultOpts,
      ...other,
    };
    if (!Object.prototype.hasOwnProperty.call(opts, 'visible') || typeof opts.visible !== 'boolean') {
      opts.visible = this.state.visible;
    }

    const wrapModalClassName = wrapClassName ? `${wrapClassName} ${this.simpleClass}` : `${this.simpleClass}`;
    return (
      <ConfigConsumer>
        {({ pagePoint }: ConfigConsumerEProps) =>
          pagePoint ? (
            <PagePoint
              compType="Modal"
              {...this.props}
              render={eventprops => (
                <AntdModal {...opts} {...eventprops} wrapClassName={wrapModalClassName} data-ui-role="Modal">
                  {children}
                </AntdModal>
              )}
            ></PagePoint>
          ) : (
            <AntdModal
              {...opts}
              wrapClassName={wrapModalClassName}
            >{children}</AntdModal>
          )
        }
      </ConfigConsumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modal/index.tsx